import {
  EmbedOptionEnum,
  type EmbedOptionsState,
} from "~/feature/chart/components/EmbedSettings/types";
import { isConsensusSelection } from "~/feature/chart/utils/isConsensusSelection";
import type { IEmbedConfig, IEmbedEvent } from "~/feature/embed/types";
import type { IEmbedSize } from "~/feature/embed/utils/getEmbedMinSize";
import type { IMarket } from "~/types/event";

interface IToEmbedConfigParams {
  event: IEmbedEvent;
  markets: IMarket[];
  selections: string[];
  options: EmbedOptionsState;
  size: IEmbedSize | null;
}

export const toEmbedConfig = ({
  event,
  markets,
  selections,
  options,
  size,
}: IToEmbedConfigParams): IEmbedConfig => ({
  eventSlug: event.urlSlug ?? event.slug,
  marketIds: markets
    .filter(({ id }) => selections.includes(id))
    .map(({ id }) => id),
  chart: options[EmbedOptionEnum.CHART],
  odds: options[EmbedOptionEnum.ODDS],
  // Only a consensus selection has a consensus to show alone; the flag never
  // travels on a link that is not one.
  consensusOnly:
    options[EmbedOptionEnum.CONSENSUS_ONLY] &&
    isConsensusSelection(markets, selections),
  border: options[EmbedOptionEnum.BORDER],
  darkMode: options[EmbedOptionEnum.DARK_MODE],
  size,
});
